(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-toggle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(el) {
    var wrap = el.closest('.shopify-section');
    if (!wrap) return;

    var tabs = Array.prototype.slice.call(el.querySelectorAll('.ct__tab'));
    var groups = [];
    var sib = wrap.nextElementSibling;

    tabs.forEach(function (tab) {
      var n = parseInt(tab.dataset.count, 10) || 0;
      var group = [];
      while (group.length < n && sib) {
        if (sib.classList.contains('shopify-section')) group.push(sib);
        sib = sib.nextElementSibling;
      }
      groups.push(group);
    });

    function show(i, focus) {
      tabs.forEach(function (tab, j) {
        var on = i === j;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        groups[j].forEach(function (s) {
          if (on) s.removeAttribute('data-ct-hidden');
          else s.setAttribute('data-ct-hidden', '');
        });
      });
      if (focus) tabs[i].focus();
      // Let lazy images, sliders etc. recalculate once revealed
      window.dispatchEvent(new Event('resize'));
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        show(i);
        if (history.replaceState) history.replaceState(null, '', '#' + tab.dataset.slug);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); show(next, true); }
      });
    });

    // Open a specific tab via URL, e.g. /pages/inks#cartridges
    var hash = decodeURIComponent(location.hash.slice(1));
    var start = tabs.findIndex(function (t) { return t.dataset.slug === hash; });
    show(start >= 0 ? start : 0);

    el._ctGroups = groups;
    el._ctShow = show;
    el._ctTabs = tabs;
  }

  function initAll() {
    document.querySelectorAll('[data-ct-hidden]').forEach(function (s) {
      s.removeAttribute('data-ct-hidden');
    });
    document.querySelectorAll('[data-ct]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support: rebuild when sections change, and switch to
  // the right tab when you click a section or tab block in the sidebar.
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(initAll, 0); });
  });

  document.addEventListener('shopify:section:select', function (e) {
    document.querySelectorAll('[data-ct]').forEach(function (el) {
      if (!el._ctGroups) return;
      var gi = el._ctGroups.findIndex(function (g) { return g.indexOf(e.target) !== -1; });
      if (gi >= 0) el._ctShow(gi);
    });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('[data-ct]');
    if (el && el._ctTabs) {
      var i = el._ctTabs.indexOf(e.target);
      if (i >= 0) el._ctShow(i);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var buttons = root.querySelectorAll('.sl__filter');
    var groups = root.querySelectorAll('.sl__group');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.dataset.filter;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        groups.forEach(function (g) { g.hidden = !(f === 'all' || g.dataset.state === f); });
      });
    });
  }
  function initAll() { document.querySelectorAll('[data-sl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sl]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
